module.exports = __webpack_public_path__ + "img/ico-search.1e68c78b.svg";